export default __webpack_public_path__ + "static/media/3-1-1.7395d758.webp";